<template>
<div class="loginCover">
  <div class="login">
    <div class="login-form">
      <div class="login-left">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <div class="login-logo">
            <img
              src="../../assets/image/logo_bak.png"
              width="246"
              alt=""
            />
          </div>
          <div class="input-icon">
            <div class="login-title">SCM系统</div>
            <p class="login-title-info">账号</p>
            <el-form-item label="" prop="loginId">
              <el-input placeholder="请输入账号" v-model="ruleForm.loginId">
              </el-input>
            </el-form-item>
            <p class="login-title-info">密码</p>
            <el-form-item label="" prop="password">
              <el-input placeholder="请输入密码" v-model="ruleForm.password" show-password @keyup.enter.native="loginHandle">
              </el-input>
            </el-form-item>
            <el-button class="login-btn" :loading="isLogining" @click.native.prevent="loginHandle"
              >登录</el-button
            >
          </div>
        </el-form>
      </div>
      <div class="login-right">
        <div class="tab-login">
          <span @click="() => LOGIN_TYPE = 'FEISHU'" :class=" LOGIN_TYPE == 'FEISHU' ? 'tab-active' : ''">飞书登录</span>
          <span @click="() => LOGIN_TYPE = 'WECHAT'" :class=" LOGIN_TYPE == 'WECHAT' ? 'tab-active' : ''">企微登录</span>
        </div>
        <div v-show="LOGIN_TYPE == 'WECHAT'" id="scm_qr_login"></div>
        <div v-show="LOGIN_TYPE == 'FEISHU'" id="fs_reg"></div>
      </div>
    </div>
    <!-- <div class="backstretch">
      <TransitionGroup name="fade" mode="out-in">
        <img key="1" class="login-bg" src="" alt="" />
      </TransitionGroup>
    </div> -->
  </div>
</div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      LOGIN_TYPE: 'FEISHU',
      ruleForm: {
        loginId: "",
        password: "",
      },
      isLogining: false,
      interval: null,
      rules: {
        loginId: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        // verify: [
        //   {
        //     required: true,
        //     message: "请输入验证码",
        //     trigger: "blur",
        //   },
        // ],
      },
      appid: '',
      agentid: '',
      redirectUri: '',
      clientIdObj: {
        uat: 'cli_a533526fe0f95013',
        production: 'cli_a554595244ae500e'
      },
      fsLoginUrl: {
        uat: 'https://test-scm.trendy-global.com/app-scm-plugin/ad/feishu/authorizeCallBack',
        production: 'https://tscm.trendygroup-it.com/app-scm-plugin/ad/feishu/authorizeCallBack',
      },
      fsRedirectUrl: '',
      QRLoginObj: '', 
      cacheUrl: {
        uat: 'http://tscm-logic.uat.trendy-global.com/initCache',
        production: 'https://tscm-logic.trendygroup-it.com/initCache'
      },
    };
  },
  methods: {
    init() {
    },
    // 登录
    loginHandle() {
      if(!this.ruleForm.loginId || !this.ruleForm.password) return;
      this.isLogining = true
      this.$apis.autoAPi
        .POST_AD_LOGIN({
          loginId: this.ruleForm.loginId,
          password: this.$utils.encrypt(this.ruleForm.password),
        })
        .done(async (resp) => {
          try{
            window.sessionStorage.timeStamp = new Date().getTime().toString();
            let powerRouterList = await this.$store.dispatch('getPowerRouterList', resp.data.id)
            this.isLogining = false
            this.$store.dispatch('savePowerRouterList', powerRouterList)
            this.$store.dispatch('login', resp.data)
            this.$router.push('/')
            this.loadInitCache()
          } catch(err) {
            if(err.code == -11) {
              this.$message.error(err.message)
            }
            this.isLogining = false
          }
        })
        .fail((err) => {
          this.isLogining = false
        });
    },
    WwLogin() {
      if(window && window.WwLogin) {
        window.WwLogin({
          id: 'scm_qr_login',
          appid : this.appid,
          agentid : this.agentid,
          redirect_uri : encodeURIComponent(this.redirectUri),
          state : "", 
        })
      }
    },
    initFSWrapper() {
      this.fsRedirectUrl = 'https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=' + this.clientIdObj[this.env] +
        '&redirect_uri=' + this.fsLoginUrl[this.env] +
        '&response_type=code&login_type=feishu';
      this.QRLoginObj = window.QRLogin({ 
        id: 'fs_reg', //二维码展示区域的元素id
        goto: this.fsRedirectUrl,
        width: '540', //二维码展示区域的宽（二维码的尺寸固定为250px*250px)
        height: '540', //二维码展示区域的高
        style: 'width:360px;height:400px; border: none;' //可选的，二维码html标签的style属性 
      })
      if (typeof window.addEventListener != 'undefined') {
        window.addEventListener('message', this.handleMessage, false);
      } else if (typeof window.attachEvent != 'undefined') {
        window.attachEvent('onmessage', this.handleMessage);
      } 
    },
    handleMessage() {
      var origin = event.origin;
      if (this.QRLoginObj.matchOrigin(origin)) {
        var loginTmpCode = event.data;
        window.location.href = `${this.fsRedirectUrl}&tmp_code=${loginTmpCode}&login_type=feishu`;
      }
    }, 

    // wxLogin(code) {
    //   this.$apis.autoAPi.POST_AD_WX_QRLOGIN({
    //     wxCode: code
    //   }).done(async resp => {
    //     window.sessionStorage.timeStamp = new Date().getTime().toString();
    //     let powerRouterList = await this.$store.dispatch('getPowerRouterList', resp.data.id)
    //     this.$store.dispatch('savePowerRouterList', powerRouterList)
    //     this.$store.dispatch('login', resp.data)
    //     this.$router.push('/')
    //   }).fail(err => {
    //     this.$message({
    //       type: 'warning',
    //       message: err && err.message
    //     })
    //   })
    // },
    // 获取资源
    // async POST_AD_FIND_LOGIN_USER_RESOURCES(params) {
    //   let resourceResp = await this.POST_AD_FIND_LOGIN_USER_RESOURCES(params)
    //   let powerRouterList = []
    //   if(resourceResp && resourceResp.menuList && resourceResp.menuList.length) {
    //     _.each(resourceResp.menuList, menuItem => {
    //       if(!menuItem.resUrl) {
    //         powerRouterList.push(menuItem)
    //       }
    //     })
    //     let menuGroup = _.groupBy(_.filter(resourceResp.menuList, item => item.resUrl), menuItem => menuItem.parentId)
    //     _.each(powerRouterList, parentMenu => {
    //       if(menuGroup[parentMenu.id]) {
    //         parentMenu.children = menuGroup[parentMenu.id]
    //       }
    //     })
    //     console.log('powerRouterList:', powerRouterList)
    //     this.$store.dispatch('savePowerRouterList', powerRouterList)
    //   }
    // },
    // POST_AD_FIND_LOGIN_USER_RESOURCES(params) {
    //   return new Promise((resolve, reject) => {
    //     this.$apis.autoAPi
    //       .POST_AD_FIND_LOGIN_USER_RESOURCES(params)
    //       .done((resp) => {
    //         resolve(resp.data)
    //       })
    //       .fail(err => {
    //         reject()
    //       })
    //   });
    // },
    loadInitCache() {
      this.$nextTick(() => {
        // 动态创建iframe，加载缓存
        let el = document.getElementById("cache");
        if(el && el.children.length) {
          el.removeChild(el.children[0])
        }
        let box = window.document.createElement("div");
        let iframe = '<iframe ref="userIframe" frameborder="0" name="rightFrame" id="rightFrame" width="0" style="background: rgb(255, 255, 255); height: 0" src="' + this.cacheUrl[this.env]+ '"></iframe>';
        box.innerHTML = iframe
        el.appendChild(box);
        this.$store.commit('SET_CACHE_IFRAME_PAGE')
      })
    }
  },
  mounted() {
    this.init();
    // this.$store.dispatch('logout', this.$store.state.userInfo && this.$store.state.userInfo.id)
    if(this.env == 'uat') {
      this.appid = 'wxba0ab253b7685ce7'
      this.agentid = '1000138'
      this.redirectUri = 'http://tscm.uat.trendy-global.com/app-scm-plugin/ad/wx/wxQrCallBack?targetUrl=http://tscm.uat.trendy-global.com/dashboard'
    } else {
      // prod
      this.appid = 'wxba0ab253b7685ce7'
      this.agentid = '1000144'
      this.redirectUri = 'https://tscm.trendygroup-it.com/app-scm-plugin/ad/wx/wxQrCallBack?targetUrl=https://tscm.trendygroup-it.com/dashboard'
    }
    this.WwLogin()
    this.initFSWrapper()
  },

  watch: {
    // '$route.query': {
    //   handler(newValue, oldValue) {
    //     if(newValue && newValue.code) {
    //       this.wxLogin(newValue.code)
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },
  computed: {
    env() {
      if (window.location.host.includes(".uat.")) {
        return 'uat'
      } return 'production'
    }
  },

  beforeRouteLeave() {
    clearInterval(this.interval);
  },
};
</script>

<style>
.loginCover {
  background-image: url('src/assets/image/login_bg.jpg');
  background-size: cover;
}
.login-form {
  display: flex;
  width: 900px;
  height: 540px;
  margin: auto;

}
.login-left {
  width: 550px;
  height: 100%;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px 0px 0px 8px;
}
.login-logo {
  width: 460px;
  height: 80px;
  margin-bottom: 32px;
}
.login-logo img {
  margin-bottom: 15px;
}
.login-title {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 500;
  margin-bottom: 16px;
}
.login-title-info {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  letter-spacing: 0;
  margin-bottom: 10px;
}

.input-icon {
  padding: 0 60px;
}

.input-icon .icon {
  color: #ccc;
  display: block;
  padding: 11px 23px 4px 10px;
  z-index: 3;
  width: 16px;
  font-size: 20px;
  text-align: center;
  left: 0;
  height: 100%;
  box-sizing: border-box;
}
.login .el-input-group__prepend {
  padding: 0;
}

.login .el-button {
  width: 100%;
  margin-top: 20px;
  background-color: #050a0d;
  color: #fff;
  border: 1px solid #050a0d;
}

.login-input {
  margin-bottom: 10px;
}

.login-right {
  width: 350px;
  height: 100%;
  background-color: #f7f9ff;
  opacity: 0.95;
  border-radius: 0px 8px 8px 0px;
}
.login-right iframe {
  width: 100%;
  height: 444px;
  transform: scale(0.7);
}
.login-btn {
  width: 152px !important;
  height: 44px;
}
/* .backstretch {
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0px;
  padding: 0px;
  height: 100vh;
  width: 100vw;
  z-index: -999999;
  position: fixed;
} */
#scm_qr_login {
  /* margin-top: 78px; */
}
.tab-login {
  height: 78px;
  text-align: center;
}
.tab-login span {
  margin-left: 25px;
  line-height: 78px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
}
.tab-active {
  color: #409eff;
}
.login-bg {
  position: absolute;
  margin: 0px;
  padding: 0px;
  border: none;
  height: auto;
  width: 100%;
  max-height: none;
  max-width: none;
  z-index: -999999;
  left: 0px;
}
</style>